<template>
<span>
  <v-btn :disabled="!active" block class="table-button center" color="light-green darken-2" round small
         @click="showResults">
    <span style="margin-right: 10px; font-weight: bold" :class="{ 'counter-active': active }">
      {{ rows_amount }}
    </span>
    <v-icon color="white">list</v-icon>
  </v-btn>
  <v-dialog v-model="dialog" width="80%">
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ table.name }}
      </v-card-title>
      <v-layout>
        <v-flex offset-xs10 xs1>
          <v-btn small :class="{active : editable}" @click="editable=!editable">
            <v-icon small>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table :headers="headers" :items="records" :rows-per-page-text="tableTranslations.rowsPerPageText" :no-data-text="tableTranslations.noDataText" :no-results-text="tableTranslations.noResultsText"
        :rows-per-page-items="pagination.rowsPerPageItems" :pagination.sync="pagination" class="elevation-1">

        <template slot="headers" slot-scope="props">
          <tr>
            <th class="header" style="word-wrap: break-word; white-space: normal" v-for="(header,index) in props.headers" :key="header.text+'_'+index">
              <span> {{ header.text }} </span>
              <v-tooltip top v-if="hasDescription(header.value)">
                <template v-slot:activator="{ on :  on }">
                  <v-icon style="margin: -1px 5px;" class="center" color="blue darken-3" small v-on="on">info</v-icon>
                </template>
                <span>{{ getSchemaField(header.value).description }}</span>
              </v-tooltip>
            </th>
          </tr>
        </template>


        <template slot="items" slot-scope="props">
          <td v-for="(header, index) in headers" :key="index" style="padding: 12px 24px" :class="{ 'unvalidate': !isValidate(props.item, header.value) }" class="text-xs-center pretty-display">
            <div v-if="header.type === fieldType.PERMAMENT">{{ props.item[header.value] }}</div>

            <div v-else-if="header.type === fieldType.PHOTO || header.type === fieldType.SIGNATURE">
              <ImageField v-if="props.item[header.value].data != null && props.item[header.value].data.length >10 "
                          :data="props.item[header.value].data" :field="getSchemaField(header.value)"></ImageField>
            </div>

            <div v-else-if='header.type === fieldType.RELATED'>
              <Related :code="props.item[header.value].data" :field="getSchemaField(header.value)" />
            </div>

            <div v-else-if='header.type === fieldType.DEPEND '>
              <Depend :code="props.item[header.value].data" :field="getSchemaField(header.value)" />
            </div>

            <div v-else-if='header.type === fieldType.STORAGE'>
                {{ props.item[header.value].data.name }} - {{ props.item[header.value].data.amount }}
              </div>

            <div v-else-if='header.type === fieldType.RADIO'>
              <Radio :context="createContext(props.item)" :formData="props.item" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data"
                v-on:updateField="updateField(props.item.id, props.item[header.value], header, $event)" :validation="props.item[header.value].validation" />
            </div>


            <div v-else-if='header.type === fieldType.CHECKBOX'>
              <Checkbox :context="createContext(props.item)" :formData="props.item" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data"
                v-on:updateField="updateField(props.item.id, props.item[header.value], header, $event)" :validation="props.item[header.value].validation" />
            </div>

            <div v-else>
              <CustomField :context="createContext(props.item)" :editable="editable" :field=getSchemaField(header.value) :valueField="props.item[header.value].data"
                v-on:updateField="updateField(props.item.id, props.item[header.value], header, $event)" :validation="props.item[header.value].validation">
              </CustomField>
            </div>

          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</span>
</template>

<script>
import Context from '@/plugins/Context'
import fieldType from '@/enums/fieldType'
import http from '@/plugins/http'
import TableAdapter from '@/plugins/TableAdapter'
import FieldUpdate from '@/plugins/FieldUpdate'
import CustomField from './CustomField'
import Related from './Related'
import Depend from './Depend'
import Checkbox from './Checkbox'
import Radio from './Radio'
import ImageField from "./ImageField.vue";

export default {
  components: {
    ImageField,
    CustomField,
    Related,
    Depend,
    Checkbox,
    Radio
  },
  props: ['table', 'rows_amount', 'form_id', 'context'],
  data() {
    return {
      pagination: this.$store.getters.pagination,
      dialog: false,
      headers: [],
      records: [],
      editable: false
    }
  },
  computed: {
    fieldType() {
      return fieldType
    },
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
    active() {
      return this.rows_amount > 0
    }
  },
  methods: {
    createContext(tableRecord) {
      return Context.createFullTableContext(tableRecord.id, this.table['sub-fields'], tableRecord, this.context)
    },
    isValidate(result, order) {
      if (result[order] != undefined && result[order].validation != undefined && order >= 1)
        return result[order].validation.pass

      return true;
    },
    showResults() {
      this.$emit('loading', true)
      http.get('form/' + this.$route.params.schemaId + '/' + this.form_id)
        .then(({
          data
        }) => {
          let adapter = new TableAdapter(this.table['sub-fields'])
          let subRecords = data.results.find(result => result.order === this.table.order).value
          adapter.loadForms(subRecords)
          this.headers = adapter.getHeaders()
          this.records = adapter.getRecords()
          this.$emit('loading', false)
          this.dialog = true
        })
    },
    updateField(idTable, fieldToUpdate, header, value) {
      let schemaField = this.getSchemaField(header.value)
      let schema = this.$route.params.schemaId

      http.put('form-table/' + schema + "/" + this.form_id + "/" + this.table.order, {
        "id": idTable,
        "results": [{
          "order": header.value,
          "value": value
        }]
      })
        .then(() => {
          (new FieldUpdate(schemaField)).setValue(fieldToUpdate, value)
          this.$store.commit('setSnack', {
            message: this.$t('form.update.success-message'),
            color: 'success'
          })
        }).catch(() => {
          this.$store.commit('setSnack', {
            message: this.$t('form.update.error-message'),
            color: 'danger'
          })
        })
    },
    getSchemaField(order) {
      return this.$store.state.forms.schema.fields.find(field => field.order == this.table.order)["sub-fields"].find(subField => subField.order == order)
    },
    hasDescription(filedOrder) {
      let field = this.getSchemaField(filedOrder)

      if (field != undefined && field.description != null && field.description.length > 3)
        return true
    },
    openImage(base64, type) {
      let win = window.open("")
      win.document.write('<img src=\'data:' + type + ";base64," + encodeURI(base64) + "'></img>");
    }
  }
}
</script>

<style scoped>
.counter-active {
  color: #efefef;
}

.unvalidate {
  background-color: #ff4d4d !important;
}

.table-button {
  width: 80px;
}

.active {
  background-color: green !important;
}

.pretty-display {
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
  padding: 10px 24px;

}

.header {
  width: 250px;
}

.center {
  margin: 0 auto;
}
</style>
